<template>
    <div class="materials-list">
        <ul class="list-group">
            <li class="list-group-item" v-for="material in paginatedItems" :key="material.id">
                <div class="material">
                    <div class="material-left">
                        <a 
                            v-if="!isFavorite"
                            class="btn btn-link icon-star" 
                            :class="{favorite: isUserFavorite(material)}"
                            @click="favoriteMaterial(material)"
                        ></a>
                        <div 
                            v-else 
                            class="module-icons mr-3 favorites" 
                            :class="getModuleStyle(material)"
                        ></div>
                        <div class="material-info">
                            <a v-if="material.is_video"
                                :href="'#'+material.main_link.url" 
                                @click="showVideo(material.main_link, material)"
                                data-toggle="modal"
                                data-target="#video-modal"
                            >
                                {{material.name}}
                            </a>
                            <a v-else :href="$basePath+'/tips-and-materials/'+material.slug" target="material">{{material.name}}</a>
                                <small v-if="material.secondary_link">
                                    (<a v-if="material.is_video"
                                        :href="'#'+material.secondary_link.url" 
                                        @click="showVideo(material.secondary_link)"
                                    >
                                        Spanish version
                                    </a>
                                    <a v-else :href="$basePath+'/tips-and-materials/'+material.slug+'?link=secondary'" target="material">Spanish version</a>)
                                </small>
                        </div>
                        <div class="material-link">
                            <a :href="material.source_url">{{material.source_name}}</a>
                            <span v-if="material.source_location">, {{material.source_location}}</span>
                        </div> 
                    </div>
                    <div class="material-tags">
                        <small v-for="(tag, idx) in material.tags" :key="tag.id">
                            <span v-if="idx > 0">,</span> 
                            <a class="material-tag" :href="$basePath+'/tips-and-materials/search?search_term='+tag.name.en">{{ tag.name.en.toUpperCase() }}</a>
                        </small>
                    </div>
                </div>
            </li>
        </ul>    
        <div class="row pagination-row justify-content-center">
            <nav aria-label="Page navigation for list of Connected Programs">
                <ul class="pagination mt-3 mx-3" role="menubar">
                    <li class="page-item" :class="{'disabled': isOnFirstPage}">
                        <button class="page-link" @click="prevPage" aria-label="Go to previous page">Previous</button>
                    </li>
                    <li v-for="pageNum in pageCount" class="page-item" :class="{'active': pageNum == currentPage}" :aria-label="`Go to page ${pageNum}`">
                        <button class="page-link" @click="setPage(pageNum)">{{ pageNum }}</button>
                    </li>
                    <li class="page-item" :class="{'disabled': isOnLastPage}">
                        <button class="page-link" @click="nextPage" aria-label="Go to next page">Next</button>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>

<style lang="scss">
@import "../../../sass/variables";
@import "../../../sass/pages/tips_and_materials";
</style>

<script>
    import Auth from '../../auth.js'
    import { mapWritableState } from 'pinia'
    import { useMaterialsStore } from './store.js';

    export default {
        props: {
            materials: {
                required: true,
                type: Array
            },
            isFavorite: {
                type: Boolean,
                default: false
            },
            paginated: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                perPage: 5,
                currentPage: 1,
                userFavorites: [],
            }
        },
        computed: {
            pageCount: function() {
                return Math.ceil(this.materials.length/this.perPage);
            },
            paginatedItems: function() {
                let start = (this.currentPage-1) * this.perPage;
                return this.materials.slice(start, start + this.perPage);
            },
            isOnFirstPage: function() {
                return this.currentPage == 1;
            },
            isOnLastPage: function() {
                return this.currentPage == this.pageCount;
            },
            ...mapWritableState(useMaterialsStore, {
                currentVideo: 'video'
            }),
        },
        methods: {
            showVideo(video, material) {
                if(typeof video ==="string") {
                    this.currentVideo = JSON.parse(video);
                }
                else{
                    this.currentVideo = video
                }
            },
            getModuleStyle(material) {
                const icon = material.sections[0].module.icon
                const style = (this.isUserFavorite(material)) ? 'favorite' : '';
                return style + ' ' + icon;

            },
            favoriteMaterial(material) {
                if (this.userFavorites.indexOf(material.id) == -1) {
                    return window.axios.post('/api/users/'+Auth.user.id+'/materials', {material_id: material.id})
                        .then((response) => {
                            this.userFavorites.push(response.data.material_id)
                        })
                        .catch((error) => console.log('error'));
                }
                return window.axios.delete('/api/users/'+Auth.user.id+'/materials/'+material.id)
                    .then((response) => this.userFavorites.splice(this.userFavorites.indexOf(material.id), 1))
                    .catch((error) => console.error(error))
            },
            isUserFavorite(material) {
                return this.userFavorites.indexOf(material.id) > -1
            },
            setPage: function(page) {
                this.currentPage = page;
            },
            nextPage: function() {
                if(this.currentPage >= this.pageCount) {
                    this.currentPage = this.pageCount;
                } else {
                    this.currentPage++;
                }
            },
            prevPage: function() {
                if(this.currentPage <= 1) {
                    this.currentPage = 1;
                } else {
                    this.currentPage--;
                }
            },
            resetPage: function() {
                this.setPage(1);
            },
        },
        mounted() {
            this.userFavorites = Auth.user.favorite_materials.map((item) => item.id);
            useMaterialsStore()
        }
        //component definition
    }
</script>